import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import { PATH } from '../../constants/path';
import headerService from '../../services/header';
import { BRAND_NAME, COMPANY_NAME, STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import SearchComponent from './search/SearchComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';
import MemberNavComponent from './membernav/MemberNavComponent';
import MobileMemberNavComponent from './membernav/MobileMemberNavComponent';

import './HeaderComponent.scss';

class HeaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stateOpenMenuMobileSlide: false
        };
    }

    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MENU_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const {
            i18n,
            user,
            isAuthenticated,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide
        } = this.props;

        return (
            <header className="tetedepage conteneur flex-container-h flex-center-alt">
                <LocalizedNavLink to={PATH.HOME_PATH} className="logo" name="headerLogo-toHome">
                    <img src={`${STATIC_ROOT}/logo.png`} alt={BRAND_NAME} width="130" height="53" />
                </LocalizedNavLink>
                <span className="logo-text">{convertHtmlToReactDomWithParams(i18n.text)}</span>
                <img
                    src={`${STATIC_ROOT}/credit-agricole-logo.png`}
                    className="company-logo"
                    alt={COMPANY_NAME}
                    width="35"
                    height="24"
                />
                <SearchComponent
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                />
                <MemberNavComponent
                    user={user}
                    isAuthenticated={isAuthenticated}
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                />
                <MobileMemberNavComponent
                    isAuthenticated={isAuthenticated}
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                />
                <button
                    className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                        stateOpenMenuMobileSlide ? 'open' : ''
                    }`}
                    id="menu-mobile-bt"
                    data-target="menu"
                    onClick={this.onClickBtMenuMobile.bind(this)}>
                    <span />
                </button>
            </header>
        );
    }
}

HeaderComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.logo,
        isAuthenticated: state.authentication.isAuthenticated,
        user: toPlainObject(state.account.user),
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide
    };
}

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js